// source: paint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var models_pb = require('./models_pb.js');
goog.object.extend(proto, models_pb);
goog.exportSymbol('proto.proto.paint.EraseRequest', null, global);
goog.exportSymbol('proto.proto.paint.EraseResponse', null, global);
goog.exportSymbol('proto.proto.paint.PaintCell', null, global);
goog.exportSymbol('proto.proto.paint.PaintCellsRequest', null, global);
goog.exportSymbol('proto.proto.paint.PaintMultipleRequest', null, global);
goog.exportSymbol('proto.proto.paint.PaintRequest', null, global);
goog.exportSymbol('proto.proto.paint.PaintResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.PaintCellsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.paint.PaintCellsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.PaintCellsRequest.displayName = 'proto.proto.paint.PaintCellsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.EraseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.paint.EraseRequest.repeatedFields_, null);
};
goog.inherits(proto.proto.paint.EraseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.EraseRequest.displayName = 'proto.proto.paint.EraseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.EraseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.paint.EraseResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.paint.EraseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.EraseResponse.displayName = 'proto.proto.paint.EraseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.PaintRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.paint.PaintRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.PaintRequest.displayName = 'proto.proto.paint.PaintRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.PaintMultipleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.paint.PaintMultipleRequest.repeatedFields_, null);
};
goog.inherits(proto.proto.paint.PaintMultipleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.PaintMultipleRequest.displayName = 'proto.proto.paint.PaintMultipleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.PaintResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.paint.PaintResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.paint.PaintResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.PaintResponse.displayName = 'proto.proto.paint.PaintResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.paint.PaintCell = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.paint.PaintCell, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.paint.PaintCell.displayName = 'proto.proto.paint.PaintCell';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.PaintCellsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.PaintCellsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.PaintCellsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintCellsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    simulationid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    featurecollection: jspb.Message.getFieldWithDefault(msg, 2, ""),
    is3x3: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.PaintCellsRequest}
 */
proto.proto.paint.PaintCellsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.PaintCellsRequest;
  return proto.proto.paint.PaintCellsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.PaintCellsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.PaintCellsRequest}
 */
proto.proto.paint.PaintCellsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSimulationid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeaturecollection(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIs3x3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.PaintCellsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.PaintCellsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.PaintCellsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintCellsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSimulationid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFeaturecollection();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIs3x3();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string SimulationId = 1;
 * @return {string}
 */
proto.proto.paint.PaintCellsRequest.prototype.getSimulationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.paint.PaintCellsRequest} returns this
 */
proto.proto.paint.PaintCellsRequest.prototype.setSimulationid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FeatureCollection = 2;
 * @return {string}
 */
proto.proto.paint.PaintCellsRequest.prototype.getFeaturecollection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.paint.PaintCellsRequest} returns this
 */
proto.proto.paint.PaintCellsRequest.prototype.setFeaturecollection = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is3x3 = 3;
 * @return {boolean}
 */
proto.proto.paint.PaintCellsRequest.prototype.getIs3x3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.paint.PaintCellsRequest} returns this
 */
proto.proto.paint.PaintCellsRequest.prototype.setIs3x3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.paint.EraseRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.EraseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.EraseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.EraseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.EraseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    simulationid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    indexesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.EraseRequest}
 */
proto.proto.paint.EraseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.EraseRequest;
  return proto.proto.paint.EraseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.EraseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.EraseRequest}
 */
proto.proto.paint.EraseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSimulationid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIndexes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.EraseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.EraseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.EraseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.EraseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSimulationid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIndexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional string SimulationId = 1;
 * @return {string}
 */
proto.proto.paint.EraseRequest.prototype.getSimulationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.paint.EraseRequest} returns this
 */
proto.proto.paint.EraseRequest.prototype.setSimulationid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 Indexes = 2;
 * @return {!Array<number>}
 */
proto.proto.paint.EraseRequest.prototype.getIndexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.paint.EraseRequest} returns this
 */
proto.proto.paint.EraseRequest.prototype.setIndexesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.paint.EraseRequest} returns this
 */
proto.proto.paint.EraseRequest.prototype.addIndexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.paint.EraseRequest} returns this
 */
proto.proto.paint.EraseRequest.prototype.clearIndexesList = function() {
  return this.setIndexesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.paint.EraseResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.EraseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.EraseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.EraseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.EraseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cellindexesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.EraseResponse}
 */
proto.proto.paint.EraseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.EraseResponse;
  return proto.proto.paint.EraseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.EraseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.EraseResponse}
 */
proto.proto.paint.EraseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCellindexes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.EraseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.EraseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.EraseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.EraseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCellindexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 CellIndexes = 1;
 * @return {!Array<number>}
 */
proto.proto.paint.EraseResponse.prototype.getCellindexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.paint.EraseResponse} returns this
 */
proto.proto.paint.EraseResponse.prototype.setCellindexesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.paint.EraseResponse} returns this
 */
proto.proto.paint.EraseResponse.prototype.addCellindexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.paint.EraseResponse} returns this
 */
proto.proto.paint.EraseResponse.prototype.clearCellindexesList = function() {
  return this.setCellindexesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.PaintRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.PaintRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.PaintRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    simulationid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    index: jspb.Message.getFieldWithDefault(msg, 2, 0),
    landslideid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    is3x3: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.PaintRequest}
 */
proto.proto.paint.PaintRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.PaintRequest;
  return proto.proto.paint.PaintRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.PaintRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.PaintRequest}
 */
proto.proto.paint.PaintRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSimulationid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLandslideid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIs3x3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.PaintRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.PaintRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.PaintRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSimulationid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLandslideid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIs3x3();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string SimulationId = 1;
 * @return {string}
 */
proto.proto.paint.PaintRequest.prototype.getSimulationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.paint.PaintRequest} returns this
 */
proto.proto.paint.PaintRequest.prototype.setSimulationid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 Index = 2;
 * @return {number}
 */
proto.proto.paint.PaintRequest.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.paint.PaintRequest} returns this
 */
proto.proto.paint.PaintRequest.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 LandslideId = 3;
 * @return {number}
 */
proto.proto.paint.PaintRequest.prototype.getLandslideid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.paint.PaintRequest} returns this
 */
proto.proto.paint.PaintRequest.prototype.setLandslideid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is3x3 = 4;
 * @return {boolean}
 */
proto.proto.paint.PaintRequest.prototype.getIs3x3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.paint.PaintRequest} returns this
 */
proto.proto.paint.PaintRequest.prototype.setIs3x3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.paint.PaintMultipleRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.PaintMultipleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.PaintMultipleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.PaintMultipleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintMultipleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    simulationid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    indexesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    landslideid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    is3x3: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.PaintMultipleRequest}
 */
proto.proto.paint.PaintMultipleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.PaintMultipleRequest;
  return proto.proto.paint.PaintMultipleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.PaintMultipleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.PaintMultipleRequest}
 */
proto.proto.paint.PaintMultipleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSimulationid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIndexes(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLandslideid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIs3x3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.PaintMultipleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.PaintMultipleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.PaintMultipleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintMultipleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSimulationid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIndexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getLandslideid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIs3x3();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string SimulationId = 1;
 * @return {string}
 */
proto.proto.paint.PaintMultipleRequest.prototype.getSimulationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.setSimulationid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 Indexes = 2;
 * @return {!Array<number>}
 */
proto.proto.paint.PaintMultipleRequest.prototype.getIndexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.setIndexesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.addIndexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.clearIndexesList = function() {
  return this.setIndexesList([]);
};


/**
 * optional int32 LandslideId = 3;
 * @return {number}
 */
proto.proto.paint.PaintMultipleRequest.prototype.getLandslideid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.setLandslideid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is3x3 = 4;
 * @return {boolean}
 */
proto.proto.paint.PaintMultipleRequest.prototype.getIs3x3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.paint.PaintMultipleRequest} returns this
 */
proto.proto.paint.PaintMultipleRequest.prototype.setIs3x3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.paint.PaintResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.PaintResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.PaintResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.PaintResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paintcellsList: jspb.Message.toObjectList(msg.getPaintcellsList(),
    proto.proto.paint.PaintCell.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.PaintResponse}
 */
proto.proto.paint.PaintResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.PaintResponse;
  return proto.proto.paint.PaintResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.PaintResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.PaintResponse}
 */
proto.proto.paint.PaintResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.paint.PaintCell;
      reader.readMessage(value,proto.proto.paint.PaintCell.deserializeBinaryFromReader);
      msg.addPaintcells(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.PaintResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.PaintResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.PaintResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaintcellsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.paint.PaintCell.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PaintCell PaintCells = 1;
 * @return {!Array<!proto.proto.paint.PaintCell>}
 */
proto.proto.paint.PaintResponse.prototype.getPaintcellsList = function() {
  return /** @type{!Array<!proto.proto.paint.PaintCell>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.paint.PaintCell, 1));
};


/**
 * @param {!Array<!proto.proto.paint.PaintCell>} value
 * @return {!proto.proto.paint.PaintResponse} returns this
*/
proto.proto.paint.PaintResponse.prototype.setPaintcellsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.paint.PaintCell=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.paint.PaintCell}
 */
proto.proto.paint.PaintResponse.prototype.addPaintcells = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.paint.PaintCell, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.paint.PaintResponse} returns this
 */
proto.proto.paint.PaintResponse.prototype.clearPaintcellsList = function() {
  return this.setPaintcellsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.paint.PaintCell.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.paint.PaintCell.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.paint.PaintCell} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintCell.toObject = function(includeInstance, msg) {
  var f, obj = {
    color: (f = msg.getColor()) && models_pb.Color.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && models_pb.Point.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.paint.PaintCell}
 */
proto.proto.paint.PaintCell.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.paint.PaintCell;
  return proto.proto.paint.PaintCell.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.paint.PaintCell} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.paint.PaintCell}
 */
proto.proto.paint.PaintCell.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new models_pb.Color;
      reader.readMessage(value,models_pb.Color.deserializeBinaryFromReader);
      msg.setColor(value);
      break;
    case 2:
      var value = new models_pb.Point;
      reader.readMessage(value,models_pb.Point.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.paint.PaintCell.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.paint.PaintCell.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.paint.PaintCell} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.paint.PaintCell.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      models_pb.Color.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      models_pb.Point.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.models.Color Color = 1;
 * @return {?proto.proto.models.Color}
 */
proto.proto.paint.PaintCell.prototype.getColor = function() {
  return /** @type{?proto.proto.models.Color} */ (
    jspb.Message.getWrapperField(this, models_pb.Color, 1));
};


/**
 * @param {?proto.proto.models.Color|undefined} value
 * @return {!proto.proto.paint.PaintCell} returns this
*/
proto.proto.paint.PaintCell.prototype.setColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.paint.PaintCell} returns this
 */
proto.proto.paint.PaintCell.prototype.clearColor = function() {
  return this.setColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.paint.PaintCell.prototype.hasColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional proto.models.Point Location = 2;
 * @return {?proto.proto.models.Point}
 */
proto.proto.paint.PaintCell.prototype.getLocation = function() {
  return /** @type{?proto.proto.models.Point} */ (
    jspb.Message.getWrapperField(this, models_pb.Point, 2));
};


/**
 * @param {?proto.proto.models.Point|undefined} value
 * @return {!proto.proto.paint.PaintCell} returns this
*/
proto.proto.paint.PaintCell.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.paint.PaintCell} returns this
 */
proto.proto.paint.PaintCell.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.paint.PaintCell.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.proto.paint);
